<template>
  <v-dialog v-model="showDialog" max-width="370">
    <v-card>
      <v-card-title class="headline">
        {{ titleText }}</v-card-title>
      <v-card-text>
        {{ dialogText }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="closeModal">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['showDialog', 'dialogText', 'titleText']),
  },
  methods: {
    closeModal() {
      this.$store.commit('toggleDialog', { show: false });
    },
  },
};
</script>
